import React from 'react'
import { Input } from 'antd'

const HEX_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i

// Native <input type="color"> only accepts #rrggbb, so expand #rgb and fall back to black
const toPickerValue = (value) => {
  if (!HEX_PATTERN.test(value || '')) return '#000000'
  if (value.length === 4) return '#' + value.slice(1).split('').map((c) => c + c).join('')
  return value
}

// Hex text input with a native colour picker swatch; works with getFieldDecorator (value/onChange)
const ColorInput = React.forwardRef(({ value, onChange, disabled }, ref) => {
  const pickerValue = toPickerValue(value)
  return (
    <Input
      ref={ref}
      value={value}
      disabled={disabled}
      allowClear
      placeholder='#52c41a'
      maxLength={7}
      autoComplete='off'
      onChange={(e) => onChange && onChange(e.target.value)}
      addonBefore={
        <input
          type='color'
          value={pickerValue}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.value)}
          style={{ width: 28, height: 22, padding: 0, border: 'none', background: 'none', cursor: 'pointer' }}
        />
      }
    />
  )
})

export default ColorInput

export { HEX_PATTERN }
